import _ from 'lodash'

export const isFirstInsertMessage = (type: number, ...payload: Array<any>) =>
	type === 1 && typeof payload[0] === 'undefined'
export const RUI_ACTIONS = ['mount', 'insertChild', 'removeChild', 'updateText', 'updateProps']

export const deepMap = (obj: Record<string, any>, cb: Function) => {
	return _.transform(obj, (result: Record<string, any>, val, key) => {
		result[key] = _.isObjectLike(val) ? deepMap(val, cb) : cb(val)
	})
}
